// import auto_login from "./auto_login";
import logout from "./logout.js";

export default {
  name: "meshLogout",
  mounted () {
    logout.mesh_logout("gide")
  }
};
